import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData, } from "../CommonComponents/CustomHooks";
import { FormButton, } from "../CommonComponents/InputBox";
import { initializeFilterData } from "../../EnvConfig/env_config";
import Pagination from '@mui/material/Pagination';
const LanguageMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [pageination, setPageination] = useState('')
    const [formData, setFormData] = useState({
        "LanguageDetail": [
            {
                "TranslationID": '',
                "key": '',
                "english": '',
                "hindi": '',
                "chinses": '',
            }
        ],
       
    })
   
    const handleSubmit = async () => {
        for (let i = 0; i < formData.LanguageDetail.length; i++) {
            const { key, english, hindi } = formData.LanguageDetail[i];
            if (!key.trim()) {
                NotificationSound('ERROR', 'Please Enter Key Value!', `txtkey${i + 1}`, inputrefs, '');
             
                return;
            } else if (!english.trim()) {
                NotificationSound('ERROR', 'Please Enter English Value!', `txtEnglish${i + 1}`, inputrefs, '');
              
                return;
            } else if (!hindi.trim()) {
                NotificationSound('ERROR', 'Please Enter Hindi Value!', `txtHindi${i + 1}`, inputrefs, '');
           
                return;
            }
        }
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateLanguageMaster', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs,);
        if (data.status === 'SUCCESS') {
            getLanguageMasterData()
        }
    };

    const getLanguageMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        // setLoading(true)
        let data = await ApiCall('/api/Master/ShowTranslationMaster', GetData)
        setPageination(data)
        setFormData({ ...formData, LanguageDetail: data.Data })
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteTranslationMaster', { TranslationID: ID }, getLanguageMasterData, '', '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        getLanguageMasterData(value);
    };
   
    const countNo = Math.ceil((parseInt(pageination?.TotalRecord) / parseInt(pageination?.PageSize)));

    useEffect(() => {
        document.title = 'Language Master'
        inputrefs.current['txtkey1'].focus()
        getLanguageMasterData()
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Language Master')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='col-md-12 col-lg-12'>
                     
                        <div className='row'>
                            <div className='mt-2'>
                                <div className=' card mb-2 border-0' >
                                    
                                    <div className='card-header mb-1' >
                                        <h6 className='m-0 mb-2 d-flex gap-2'>
                                            <div className='col-md-4'>
                                                <span>
                                                    {pageination?.TotalRecord !== undefined
                                                        ? `${FindTranslatedKey('Total Records')} : ${pageination?.TotalRecord}`
                                                        : FindTranslatedKey('No Record Found')}
                                                </span>
                                            </div>
                                        </h6>
                                        <div className='card-body' style={{ padding: '0px' }}>
                                            <div className="table-responsive">
                                                <table className="table border mb-0">
                                                    <thead>
                                                        <tr className='light-bg'>
                                                            <th style={{ padding: '5px 4px', width: "0rem" }}>{FindTranslatedKey('Del')}</th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Key')}<span style={{ color: "red" }}> *</span> </th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('English')}<span style={{ color: "red" }}> *</span> </th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Hindi')}<span style={{ color: "red" }}> *</span> </th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Chinese')}</th>
                                                           
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData?.LanguageDetail?.map((item, index) =>
                                                          
                                                            <tr key={`packageDetailsList${index + 1}`} className="TableTrhover" >
                                                                <td className='' style={{ minWidth: "10px" }} >
                                                                    {<span style={{ marginLeft: "-2px" }} >
                                                                        <i className="fa-regular fa-trash-can text-danger me-3 text-center "
                                                                            onClick={() => handleDelete(item.TranslationID)}
                                                                            style={{ marginLeft: "0px", marginTop: "4px", paddingRight: "0px" }}
                                                                        />
                                                                    </span>}
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        placeholder={FindTranslatedKey('key')}
                                                                        className="form-control w-100"
                                                                        value={item.key}
                                                                        maxLength="500"
                                                                        ref={ref => (inputrefs.current[`txtkey${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtEnglish${index + 1}`].focus();
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let list = [...formData.LanguageDetail];
                                                                            list[index] = { ...list[index], key: e.target.value };
                                                                            setFormData({ ...formData, LanguageDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />

                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.english}
                                                                        placeholder={FindTranslatedKey('English')}
                                                                        maxLength='500'
                                                                        ref={ref => (inputrefs.current[`txtEnglish${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtHindi${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let list = [...formData.LanguageDetail];
                                                                            list[index] = { ...list[index], english: e.target.value };
                                                                            setFormData({ ...formData, LanguageDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.hindi}
                                                                        maxLength='500'
                                                                        placeholder={FindTranslatedKey('Hindi')}
                                                                        ref={ref => (inputrefs.current[`txtHindi${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtChinses${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let list = [...formData.LanguageDetail];
                                                                            list[index] = { ...list[index], hindi: e.target.value };
                                                                            setFormData({ ...formData, LanguageDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.chinses}
                                                                        maxLength='500'
                                                                        placeholder={FindTranslatedKey('Chinese')}
                                                                        ref={ref => (inputrefs.current[`txtChinses${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                const nextIndex = index + 1;
                                                                                if (formData.LanguageDetail[nextIndex]) {
                                                                                    inputrefs.current[`txtkey${nextIndex + 1}`].focus();
                                                                                }
                                                                                else {
                                                                                    inputrefs.current['btnSave'].focus();
                                                                                }
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let list = [...formData.LanguageDetail];
                                                                            list[index] = { ...list[index], chinses: e.target.value };
                                                                            setFormData({ ...formData, LanguageDetail: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {countNo > 1 ?
                                                    < Pagination className='pt-2' count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange1} shape="rounded" />
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                     
                        <div className='row pb-1'>
                            <FormButton
                                id='btnSave'
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                Export={false}
                                Reset={false} />
                        </div>

                    </div>
                
                  
                </div>

            </div>

        </>
    )
}
export default LanguageMaster;